module.exports = __webpack_public_path__ + "static/img/hb_11-min.3d45784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_11-min.png
// module id = p4ZV
// module chunks = 1